export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fa047b85a2424c0a09123ac77856f4c505423946e&name=fetchTypeahead!'